<app-data-table (openRow)="openRow($event)"
                (deleteData)="delete($event)"
                (createRow)="openRow($event)"
                (addToPassedUsersEmitter)="addToPasseUsers($event)"
                (navigateToPerformance)="navigateToPerformance($event)"
                [columns]="tableColumns"
                [data]="tableData"
                (fireGetServerData)="getServerData($event)"
                (getData)="getServerData($event)"
                [hasDelete]="hasDelete"
                [hasModify]="hasModify"
                [hasManagePerformance]="true"
                [hasAdd]="hasAdd"
                [hasAddToPassedUsers]="true"
                [total]="total"
                [next_page]="next_page"
                [pluralTableLabel]="'Users'"
                [singleTableLabel]="'User'"
></app-data-table>
